import { URLS } from '@assets/environment/urls'

export const EnvPage = () => {
	return (
		<div>
			<div>Страница енвов</div>
			<div>VITE_APP_ENV {URLS.APP_ENV}</div>
			<div>VITE_WORKOUT {URLS.WORKOUT}</div>
			<div>VITE_CHAT {URLS.CHAT}</div>
			<div>VITE_MEDIA {URLS.MEDIA}</div>
			<div>VITE_KC_URL {URLS.KC_URL}</div>
			<div>VITE_KC_REALM {URLS.KC_REALM}</div>
			<div>VITE_KC_USER {URLS.KC_USER}</div>
			<div>BUILD_TIME_MOSCOW {URLS.BUILD_TIME_MOSCOW}</div>
			<div>GIT_COMMIT {URLS.GIT_COMMIT}</div>
			<div>APP_VERSION {URLS.APP_VERSION}</div>
		</div>
	)
}
